import productsController from './productsController'

export default productsController



// WEBPACK FOOTER //
// ../src/controllers/productsController/index.js